import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

import { TitleService } from './shared/services/title/title.service';
import { GoogleAnalyticsService } from './shared/services/googleAnalytics/google-analytics.service';
import { HeaderService } from './shell/services/header/header.service';

@Component({
  selector: 'dls-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _titleService: Title,
    private _title: TitleService,
    private _gtagService: GoogleAnalyticsService,
    private _headerService: HeaderService
  ) {
    // Initializing the gtag instance in application
    this._gtagService.init();
  }

  ngOnInit() {
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      tap((event: NavigationEnd) => {
        // Start tracking page navigation using gtag
        this._gtagService.startTrackingNavigation(event.urlAfterRedirects);
      }),
      map(() => this._activatedRoute),
      // Tap the root activated route and update Header
      tap((activatedRoute) => this._headerService.updateHeader(activatedRoute)),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    ).subscribe((event) => {
      this._titleService.setTitle(event['title']);
      // TODO: Remove unused code
      // this._title.sendMessage(event['title']);
    });
  }
}

